import CloseIcon from "@mui/icons-material/Close";
import { Box, Tooltip } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import React from "react";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiDialog-paperFullScreen": {
    maxWidth: "80%",
    maxHeight: "100%",
    backgroundColor: "transparent",
  },
}));

export default function CustomModel({ title, open, setOpen, content, images }) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        fullScreen
      >
        {title && (
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            {title}
          </DialogTitle>
        )}

        <Tooltip title="Close" arrow>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
              zIndex: 1000,
              background: "#f5f5f5 !important",
              color: "#1e3b6e !important",
              opacity: 0.7,
              padding: 0.5,
            }}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>

        <DialogContent
          style={{ background: "transparent !important" }}
          dividers
          sx={{ padding: "1px !important" }}
        >
          {content && content}
        </DialogContent>
      </BootstrapDialog>
    </Box>
  );
}
